<template>
    
    <header ref="headerRef" :class="['main-header fixed-header',
                ['/business', '/experts','/pricing'].includes(route.path) ? 'landing_header' : ''
            ]"
            id="header"
            >
        <div class="container">
            <div class="inner-header">
                <div class="logo animate fadeInUp one">
                    <NuxtLink to="/" class="category_item visible">
                        <NuxtImg
                            :src="websiteStore?.initializationData?.website_settings?.navbar_logo"
                            alt="Review App Logo"
                            loading="lazy"
                            class="logo-image"
                            :custom="true"
                            v-slot="{ src, isLoaded, imgAttrs }"
                        >
                            <!-- Show the actual image when loaded -->
                            <img
                            v-if="isLoaded"
                            v-bind="imgAttrs"
                            :src="src"
                            >

                            <!-- Show a placeholder while loading -->
                            <img
                            v-else
                            class="logo-image"
                            :src="'/website/assets/img/logo/review-logo.png'"
                            >
                        </NuxtImg>

                    </NuxtLink>
                </div>

                <!-- Search Box -->
                <div ref="searchBoxRef" v-if="showSearchBox" class="searchBox animate fadeInUp two">
                    <div class="search_input">
                        <!-- Note: The form action now points to the /places page -->
                        <form action="/places">
                            <input ref="searchInputRef" v-model="searchQuery" class="searchInput" type="text" name="q"
                                id="qM" autocomplete="off" />
                            <button class="searchButton" type="submit">
                                <svg id="search-normal_linear" data-name="search-normal/linear"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                    <g id="vuesax_linear_search-normal" data-name="vuesax/linear/search-normal">
                                        <g id="search-normal">
                                            <path id="Vector" d="M18,9A9,9,0,1,1,9,0,9,9,0,0,1,18,9Z"
                                                transform="translate(2 2)" fill="none" stroke="#777E90"
                                                stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                            <path id="Vector-2" data-name="Vector"
                                                d="M.1,1.97c.53,1.6,1.74,1.76,2.67.36C3.62,1.05,3.06,0,1.52,0A1.406,1.406,0,0,0,.1,1.97Z"
                                                transform="translate(18.83 18.72)" fill="none" stroke="#777E90"
                                                stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                            <path id="Vector-3" data-name="Vector" d="M0,0H24V24H0Z" fill="none"
                                                opacity="0" />
                                        </g>
                                    </g>
                                </svg>
                            </button>
                        </form>
                    </div>
                    <!-- Search Results rendered using v-for -->
                    <div ref="searchResultsRef" class="search_input_result" id="search_input_result">
                        <template v-if="places.length">
                            <NuxtLink v-for="place in places" :key="place.id" :to="generatePlaceUrl(place)"
                                class="search_item">
                                <div class="info">
                                    <div class="img">

                                        <NuxtImg
                                            :src="place.main_image"
                                            :alt="place.name"
                                            loading="lazy"
                                            :custom="true"
                                            v-slot="{ src, isLoaded, imgAttrs }"
                                        >
                                            <!-- Show the actual image when loaded -->
                                            <img
                                            v-if="isLoaded"
                                            v-bind="imgAttrs"
                                            :src="src"
                                            >

                                            <!-- Show a placeholder while loading -->
                                            <img
                                            v-else
                                            :src="'/website/assets/img/default-featured-image.jpeg'"
                                            >
                                        </NuxtImg>
                                        <!-- <img loading="lazy" :src="place.main_image || '/uploads/avatar.png'"
                                            :alt="place.name || '-'" /> -->
                                    </div>
                                    <h3>{{ place.name || '-' }}</h3>
                                </div>
                                <div class="rates">
                                    <div class="stars">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20.303" height="19.493" viewBox="0 0 20.303 19.493">
                                        <path id="star-comment-alt-2" d="M11.141,24.285a1.714,1.714,0,0,1-1.016-.333,1.686,1.686,0,0,1-.591-1.866l1.589-5.1-4.028-3.27a1.685,1.685,0,0,1,1.09-2.975h5.081l1.792-4.823a1.693,1.693,0,0,1,3.178,0l1.792,4.823H25.11A1.7,1.7,0,0,1,26.7,11.85a1.73,1.73,0,0,1-.5,1.885L22.19,17l1.663,5.044a1.677,1.677,0,0,1-.573,1.866,1.7,1.7,0,0,1-1.959.074l-4.656-3.03-4.582,3.067a1.7,1.7,0,0,1-.942.277Z" transform="translate(-6.496 -4.81)" fill="#f7b32f"/>
                                        </svg>

                                        <span class="rate">( {{ Number(place.total_rate_db).toFixed(1) }} )</span>
                                    </div>
                                    <div class="visitors">
                                        <img src="/website/assets/img/icons/circle_user.png" alt="user" />
                                        <span>{{ place.rates_count_db }}</span>
                                    </div>
                                </div>
                            </NuxtLink>
                        </template>
                        <template v-else>
                            <a href="javascript:" class="search_item">
                                <div class="info">
                                    <h3>لا توجد نتائج بحث</h3>
                                </div>
                            </a>
                        </template>
                    </div>
                </div>

                <!-- User Buttons -->
                <div class="user-buttons animate fadeInUp three">

                    <div v-if="['/business', '/experts','/pricing'].includes(route.path)">
                        <div class="user_links">
                            <ul>
                                <li><a href="/business#business">الرئيسية</a></li>
                                <li><a href="/business#features">المزايا</a></li>
                                <li>
                                <NuxtLink to="/business#business-packages">الاسعار</NuxtLink>
                                </li>
                                <li v-if="!isAuthenticated"><a href="https://business.reviewapp.sa/login">تسجيل الدخول</a></li>
                            </ul>
                        </div>
                    </div>

                    <div class="search-toggle">
                        <a href="#" class="search-toggle-btn" data-bs-toggle="modal" data-bs-target="#searchModal">
                            <svg id="search-normal_linear" data-name="search-normal/linear"
                                xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                <g id="vuesax_linear_search-normal" data-name="vuesax/linear/search-normal">
                                    <g id="search-normal">
                                        <path id="Vector" d="M18,9A9,9,0,1,1,9,0,9,9,0,0,1,18,9Z"
                                            transform="translate(2 2)" fill="none" stroke="#777E90"
                                            stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                        <path id="Vector-2" data-name="Vector"
                                            d="M.1,1.97c.53,1.6,1.74,1.76,2.67.36C3.62,1.05,3.06,0,1.52,0A1.406,1.406,0,0,0,.1,1.97Z"
                                            transform="translate(18.83 18.72)" fill="none" stroke="#777E90"
                                            stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                        <path id="Vector-3" data-name="Vector" d="M0,0H24V24H0Z" fill="none"
                                            opacity="0" />
                                    </g>
                                </g>
                            </svg>
                        </a>
                    </div>
                    <template v-if="isAuthenticated">
                        <li class="profileBtn">
                            <a href="javascript:void(0)" class="User-avtar" @click="toggleDropdown">
                                <span class="avatar">
                                    <img :src="user?.thumbnail || '/website/assets/img/avatar.png'" alt="User Avatar" />
                                </span>
                               
                                <span class="name mx-1">
                                   
                                    هلا <span>{{ user?.name?.split(' ')[0] }}</span> 👋
                                </span>

                                <i class="fi fi-rr-angle-small-down iconDown"></i>
                            </a>
                            <!-- Dropdown Menu -->
                            <ul class="User-Dropdown" :class="{ 'U-open': isDropdownOpen }">
                                <li>
                                    <NuxtLink to="/user/profile">
                                        <svg id="profile-circle_linear" data-name="profile-circle/linear" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <g id="vuesax_linear_profile-circle" data-name="vuesax/linear/profile-circle">
                                            <g id="profile-circle">
                                            <path id="Vector" d="M3.4,6.55a.963.963,0,0,0-.24,0,3.28,3.28,0,1,1,.24,0Z" transform="translate(8.72 6.23)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                            <path id="Vector-2" data-name="Vector" d="M13.48,3.945a9.934,9.934,0,0,1-6.74,2.62A9.934,9.934,0,0,1,0,3.945a3.679,3.679,0,0,1,1.77-2.58,9.73,9.73,0,0,1,9.94,0A3.679,3.679,0,0,1,13.48,3.945Z" transform="translate(5.26 15.435)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                            <path id="Vector-3" data-name="Vector" d="M20,10A10,10,0,1,1,10,0,10,10,0,0,1,20,10Z" transform="translate(2 2)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                            <path id="Vector-4" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(24 24) rotate(180)" fill="none" opacity="0"/>
                                            </g>
                                        </g>
                                        </svg>

                                        حسابي
                                    </NuxtLink>
                                </li>
                                <li>
                                    <NuxtLink to="/user/my-rates">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                            <g id="Group_1" data-name="Group 1" transform="translate(-820 -204)">
                                            <g id="trend-up_linear" data-name="trend-up/linear" transform="translate(820 204)">
                                                <g id="vuesax_linear_trend-up" data-name="vuesax/linear/trend-up">
                                                <g id="trend-up">
                                                    <path id="Vector" d="M7,20h6c5,0,7-2,7-7V7c0-5-2-7-7-7H7C2,0,0,2,0,7v6C0,18,2,20,7,20Z" transform="translate(2 2)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                                    <path id="Vector-2" data-name="Vector" d="M0,0H24V24H0Z" fill="none" opacity="0"/>
                                                </g>
                                                </g>
                                            </g>
                                            <g id="star_linear" data-name="star/linear" transform="translate(825 209)">
                                                <g id="vuesax_linear_star" data-name="vuesax/linear/star">
                                                <g id="star">
                                                    <path id="Vector-3" data-name="Vector" d="M5.865.71l.88,1.746a1.086,1.086,0,0,0,.71.521l1.6.263c1.02.169,1.26.9.525,1.627L8.335,6.1a1.071,1.071,0,0,0-.26.9L8.43,8.516c.28,1.205-.365,1.671-1.44,1.041L5.5,8.68a1.089,1.089,0,0,0-.99,0l-1.5.878c-1.07.63-1.72.159-1.44-1.041l.355-1.522a1.071,1.071,0,0,0-.26-.9L.425,4.866c-.73-.724-.5-1.458.525-1.627l1.6-.263a1.088,1.088,0,0,0,.705-.521L4.13.71C4.61-.237,5.39-.237,5.865.71Z" transform="translate(2.001 2.078)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"/>
                                                    <path id="Vector-4" data-name="Vector" d="M0,0H14V14H0Z" fill="none" opacity="0"/>
                                                </g>
                                                </g>
                                            </g>
                                            </g>
                                        </svg>
                                        تقييماتي
                                    </NuxtLink>
                                </li>
                                <!-- <li>
                                    <NuxtLink to="/my-orders">
                                       <svg id="calendar_linear" data-name="calendar/linear" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <g id="vuesax_linear_calendar" data-name="vuesax/linear/calendar">
                                            <g id="calendar">
                                            <path id="Vector" d="M0,0V3" transform="translate(8 2)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                            <path id="Vector-2" data-name="Vector" d="M0,0V3" transform="translate(16 2)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                            <path id="Vector-3" data-name="Vector" d="M0,0H17" transform="translate(3.5 9.09)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                            <path id="Vector-4" data-name="Vector" d="M18,5v8.5c0,3-1.5,5-5,5H5c-3.5,0-5-2-5-5V5C0,2,1.5,0,5,0h8C16.5,0,18,2,18,5Z" transform="translate(3 3.5)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                            <path id="Vector-5" data-name="Vector" d="M0,0H24V24H0Z" fill="none" opacity="0"/>
                                            <path id="Vector-6" data-name="Vector" d="M.495.5H.5" transform="translate(15.2 13.2)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                            <path id="Vector-7" data-name="Vector" d="M.495.5H.5" transform="translate(15.2 16.2)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                            <path id="Vector-8" data-name="Vector" d="M.495.5H.5" transform="translate(11.501 13.2)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                            <path id="Vector-9" data-name="Vector" d="M.495.5H.5" transform="translate(11.501 16.2)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                            <path id="Vector-10" data-name="Vector" d="M.495.5H.5" transform="translate(7.8 13.2)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                            <path id="Vector-11" data-name="Vector" d="M.495.5H.5" transform="translate(7.8 16.2)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                            </g>
                                        </g>
                                        </svg>


                                        طلباتي
                                    </NuxtLink>
                                </li> -->
                                <li @click="handleLogout">
                                    <a href="javascript:void(0)">
                                        <svg id="logout" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                            <path id="Vector" d="M12.59,0V2.26c0,4.47-1.79,6.26-6.26,6.26H6.2C2.18,8.52.33,7.07,0,3.53" transform="translate(8.91 13)" fill="none" stroke="#ff0000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                            <path id="Vector-2" data-name="Vector" d="M0,5.07C.31,1.47,2.16,0,6.21,0h.13c4.47,0,6.26,1.79,6.26,6.26" transform="translate(8.9 2.49)" fill="none" stroke="#ff0000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                            <path id="Vector-3" data-name="Vector" d="M11.38,0H0" transform="translate(3.62 12)" fill="none" stroke="#ff0000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                            <path id="Vector-4" data-name="Vector" d="M3.35,0,0,3.35,3.35,6.7" transform="translate(2.5 8.65)" fill="none" stroke="#ff0000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                            <path id="Vector-5" data-name="Vector" d="M0,0H24V24H0Z" fill="none" opacity="0"/>
                                            </svg>

                                        تسجيل الخروج
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </template>
                    
                    <template v-else>
                        <!-- <a href="javascript:void(0)" @click="openModal" class="user-login">
                            تسجيل الدخول
                        </a> -->


                        <a :href="loginLink" @click="handleLoginClick" class="user-login">
                            {{ loginText }}
                        </a>


                        <div v-if="['/business', '/experts','/pricing'].includes(route.path)" class="toggle-nav">
                            <button class="toggle-btn" @click="toggleMenu">
                                <svg id="vuesax_broken_more" data-name="vuesax/broken/more" xmlns="http://www.w3.org/2000/svg" width="30" height="36.75" viewBox="0 0 30 36.75">
                                    <g id="more">
                                    <path id="Vector" d="M2.5,0A2.488,2.488,0,0,0,0,2.461a2.5,2.5,0,0,0,5,0A2.488,2.488,0,0,0,2.5,0Z" transform="translate(3.75 12.303)" fill="none" stroke="#000" stroke-width="2"/>
                                    <path id="Vector-2" data-name="Vector" d="M2.5,0A2.488,2.488,0,0,0,0,2.461a2.5,2.5,0,0,0,5,0A2.488,2.488,0,0,0,2.5,0Z" transform="translate(3.75 30.829)" fill="none" stroke="#000" stroke-width="2"/>
                                    <path id="Vector-3" data-name="Vector" d="M0,2.461a2.5,2.5,0,0,0,5,0A2.488,2.488,0,0,0,2.5,0" transform="translate(3.75 21.566)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                    <path id="Vector-4" data-name="Vector" d="M0,0H30V29.526H0Z" fill="none" opacity="0"/>
                                    </g>
                                </svg>

                            </button>

                        </div>
                        
                    </template>
                </div>
            </div>
        </div>
    </header>

    <div v-if="['/business', '/experts','/pricing'].includes(route.path)" :class="{ active: isMenuActive }" @click="closeMenu" id="m-menu">
        <ul class="nav-items">
            <li><a href="/business" @click.stop="closeMenu">الرئيسية</a></li>
            <li><a href="#features" @click.stop="closeMenu">المزايا</a></li>
             <li>
                <NuxtLink to="/business#business-packages" @click.stop="closeMenu">الاسعار</NuxtLink>
                </li>
            <li v-if="!isAuthenticated"><a href="https://business.reviewapp.sa/login">تسجيل الدخول</a></li>

        </ul>
        <div class="toggle-nav active">
            <span></span><span></span><span></span>
        </div>
    </div>

</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { onClickOutside } from '@vueuse/core'
import { useWebsiteStore } from '~/store/website'
import { useBootstrapModal } from '@/composables/useBootstrapModal'
import { useAuthStore } from '@/store/auth'
import { placesRepository } from '~/utils/placesRepository'
import { useSearchBoxVisibility } from '~/utils/searchVisibility';

const { showSearchBox } = useSearchBoxVisibility();


const { $api } = useNuxtApp()
const router = useRouter()
const route = useRoute()


const authStore = useAuthStore()
const websiteStore = useWebsiteStore()
const placesRepo = placesRepository($api)

const user = computed(() => authStore.user)
const isAuthenticated = computed(() => authStore.isAuthenticated)

// Check if the current page is a business page
const businessRoutes = ['/business', '/experts', '/pricing']

const isBusinessPage = computed(() => businessRoutes.includes(route.path))

// Set href and text dynamically
const loginLink = computed(() => (isBusinessPage.value ? 'https://business.reviewapp.sa/register' : 'javascript:void(0)'))
const loginText = computed(() => (isBusinessPage.value ? 'ابدأ الآن' : 'تسجيل الدخول'))


const isDropdownOpen = ref(false)
const toggleDropdown = () => {
    isDropdownOpen.value = !isDropdownOpen.value
}
const handleLogout = () => {
    router.push('/')
    authStore.logout()
}

const { openModal } = useBootstrapModal('userModal')

const handleLoginClick = (event) => {
    if (!isBusinessPage.value) {
        event.preventDefault()
        openModal()
    }
}

const isMenuActive = ref(false)
const clicked = ref(false)

const toggleMenu = () => {
    if (!clicked.value) {
        clicked.value = true
        isMenuActive.value = !isMenuActive.value
        setTimeout(() => {
        clicked.value = false
        }, 300)
    }
}

const closeMenu = () => {
  isMenuActive.value = false
}


const headerRef = ref(null)
const searchInputRef = ref(null)
const searchBoxRef = ref(null)
const searchResultsRef = ref(null)

const searchQuery = ref('')
const places = ref([])
const loading = ref(false)

// Helper (if needed)
const getPlaceId = () => {
    const el = document.getElementById('current_place_view')
    return el ? el.innerHTML : null
}

const slugify = (text) => text.replace(/\s+/g, '-').toLowerCase()

const generatePlaceUrl = (place) => {
    const slug = place.name ? slugify(place.name) : ''
    return `/place/${place.tenant}`
}

async function fetchSearchResults(query, placeId = null) {
    loading.value = true
    try {
        const { data: placesData } = await placesRepo.get({ name: query ,from:'search', page_count : 8,
            sort : 0 }, 1)
        if (placesData) {
            places.value = placesData
            if (searchResultsRef.value && (placesData.length > 0 || query)) {
                searchResultsRef.value.classList.add('show')
                searchResultsRef.value.classList.remove('has-spinner-link')
                searchResultsRef.value.classList.remove('loading')
            }
        }
    } catch (error) {
        console.error('Error fetching search results', error)
    } finally {
        loading.value = false
    }
}

async function handleSearchInput(event) {
    if (headerRef.value) {
        headerRef.value.classList.add('withSearch')
    }
    if (searchInputRef.value && searchInputRef.value.parentElement) {
        searchInputRef.value.parentElement.classList.add('focused')
    }

    if (searchResultsRef.value) {
        searchResultsRef.value.classList.add('has-spinner-link')
        searchResultsRef.value.classList.add('loading')
    }


    const value = event.target.value;
    searchQuery.value = value

    if (value.length >= 1) {
        await fetchSearchResults(value)
    } else {
        const placeId = getPlaceId()
        await fetchSearchResults(null, placeId)
    }
}

function handleClickOutside() {
    if (searchResultsRef.value) {
        searchResultsRef.value.classList.remove('show')
    }
    if (searchInputRef.value && searchInputRef.value.parentElement) {
        searchInputRef.value.parentElement.classList.remove('focused')
    }
    if (headerRef.value) {
        headerRef.value.classList.remove('withSearch')
    }
}


const handleScroll = () => {
    const scrollTop = window.scrollY;
    const mainHeader = document.querySelector('.main-header');
    const isMobile = window.innerWidth <= 576;

    if (mainHeader) {
        if ((isMobile && scrollTop >= 20) || (!isMobile && scrollTop >= 50)) {
            mainHeader.classList.add('fixed-header-bg');
        } else {
            mainHeader.classList.remove('fixed-header-bg');
        }
    }
};

onMounted(() => {
    if (searchBoxRef.value) {
        onClickOutside(searchBoxRef, handleClickOutside)
    }
    if (searchInputRef.value) {
        searchInputRef.value.addEventListener('input', handleSearchInput)
        searchInputRef.value.addEventListener('focus', handleSearchInput)
    }



    window.addEventListener('scroll', handleScroll);

    var inputField = document.getElementById("qM");
    if (!inputField) return;

    var placeholderText = "ابحث ( مطعم , كافيه , متجر ... )";
    var typingElement = document.createElement("span");
    typingElement.classList.add("typing-placeholder");
    typingElement.textContent = placeholderText;

    // إدراج العنصر قبل حقل الإدخال
    inputField.parentNode.insertBefore(typingElement, inputField);

    // وظيفة لإظهار أو إخفاء العنصر الوهمي
    function toggleTypingPlaceholder() {
        typingElement.style.display = inputField.value === "" ? "inline" : "none";
    }

    toggleTypingPlaceholder();
    inputField.addEventListener("focus", () => (typingElement.style.display = "none"));
    inputField.addEventListener("blur", toggleTypingPlaceholder);
})

onUnmounted(() => {
    if (searchInputRef.value) {
        searchInputRef.value.removeEventListener('input', handleSearchInput)
        searchInputRef.value.removeEventListener('focus', handleSearchInput)
    }
})



</script>